module.exports = __webpack_public_path__ + "img/logo.abc0e996.svg";